// extracted by mini-css-extract-plugin
export default {"container":"LogicHomePage_container__V4T5m","title":"LogicHomePage_title__7k2l7"};